class BookstoreList extends HTMLElement {
  constructor() {
    super();
    this.search = this.querySelector('[data-bookstore-search]');
    this.filter = this.querySelector('[data-bookstore-filter]');
    this.filterBtn = this.querySelector('[data-bookstore-filter-btn]');
    this.filterLabel = this.querySelector('[data-bookstore-filter-label]');
    this.filterMenu = this.querySelector('[data-bookstore-filter-menu]');
    this.cards = Array.from(this.querySelectorAll('.bookstoreCard'));
    this.grid = this.querySelector('.bookstoreList__grid');
    this.query = '';
    this.tag = '';
  }

  connectedCallback() {
    if (this.dataset.bsInit === '1') return;
    this.dataset.bsInit = '1';

    this.searchClear = this.querySelector('[data-bookstore-search-clear]');
    this.searchWrap = this.search ? this.search.parentElement : null;

    if (this.search) {
      this.search.addEventListener('input', (e) => {
        this.query = (e.target.value || '').trim().toLowerCase();

        if (this.searchWrap) this.searchWrap.classList.toggle('has-value', this.search.value.length > 0);
        this.apply();
      });
    }
    if (this.searchClear) {
      this.searchClear.addEventListener('click', () => {
        if (!this.search) return;
        this.search.value = '';
        this.query = '';

        if (this.searchWrap) this.searchWrap.classList.remove('has-value');
        this.search.focus();
        this.apply();
      });
    }

    if (this.filterBtn && this.filterMenu) {
      this.filterBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleMenu();
      });
      this.filterMenu.addEventListener('click', (e) => {
        const option = e.target.closest('.bookstoreList__filterOption');
        if (!option) return;
        this.selectOption(option);
      });
      this._onDocClick = (e) => {
        if (!this.filter.contains(e.target)) this.closeMenu();
      };
      document.addEventListener('click', this._onDocClick);
    }
  }

  disconnectedCallback() {
    if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
  }

  toggleMenu() {
    const open = this.filter.classList.toggle('is-open');
    this.filterBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  closeMenu() {
    this.filter.classList.remove('is-open');
    this.filterBtn.setAttribute('aria-expanded', 'false');
  }

  selectOption(option) {
    const value = (option.dataset.value || '').toLowerCase();
    const label = option.querySelector('.bookstoreList__filterText')?.textContent?.trim() || '';
    this.tag = value;
    this.filterMenu.querySelectorAll('.bookstoreList__filterOption').forEach((o) => {
      const sel = o === option;
      o.classList.toggle('is-selected', sel);
      o.setAttribute('aria-selected', sel ? 'true' : 'false');
    });
    if (this.filterLabel) this.filterLabel.textContent = label;
    this.closeMenu();
    this.apply();
  }

  apply() {
    let visible = 0;
    for (const card of this.cards) {
      const title = card.dataset.title || '';
      const vendor = card.dataset.vendor || '';
      const tags = (card.dataset.tags || '').split('|').filter(Boolean);

      const matchesTag = !this.tag || tags.includes(this.tag);
      const matchesQuery = !this.query
        || title.includes(this.query)
        || vendor.includes(this.query)
        || tags.some((t) => t.includes(this.query));

      const show = matchesTag && matchesQuery;
      card.classList.toggle('is-hidden', !show);
      if (show) visible++;
    }
    this.dataset.empty = visible === 0 ? 'true' : 'false';
  }
}

if (!customElements.get('bookstore-list')) {
  customElements.define('bookstore-list', BookstoreList);
}
